var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailGreenVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8104)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8104",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0195 6.64062H4.98047C2.76917 6.64062 0.976562 8.43323 0.976562 10.6445V39.4106C0.976562 41.6219 2.76917 43.4146 4.98047 43.4146H45.0195C47.2308 43.4146 49.0234 41.6219 49.0234 39.4106V10.6445C49.0234 8.43323 47.2308 6.64062 45.0195 6.64062Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3712 43.457V15.5617H43.3706L24.9718 29.066L6.57335 15.5617V43.457H3.23908C2.63686 43.4548 2.06017 43.2135 1.63587 42.7861C1.21158 42.3588 0.974423 41.7803 0.976577 41.1781V8.91885C0.976577 7.66074 1.4799 6.64062 2.72902 6.64062H4.54884L24.9718 21.6309L45.3951 6.64062H47.0497C48.2997 6.64062 48.9676 7.66074 48.9676 8.91885V11.4528V41.1781C48.9695 41.7805 48.7321 42.359 48.3075 42.7863C47.883 43.2137 47.3061 43.4549 46.7037 43.457H43.3712Z",
    fill: "#00FF14"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGreenVerified);
export default __webpack_public_path__ + "static/media/email_green_verified.960d9718b96b1e1f94d749e6de5de3f5.svg";
export { ForwardRef as ReactComponent };